import lazyWithRetry from "../utils/lazyWithRetry";

const PromoCodes = lazyWithRetry(() => import("./PromoCodes/PromoCodes"));
const Patient = lazyWithRetry(() => import("./Patient/Patient"));
const Settings = lazyWithRetry(() => import("./Settings/Settings"));
const MyAccount = lazyWithRetry(() => import("./MyAccount/MyAccount"));
const Team = lazyWithRetry(() => import("./Team/Team"));
const Menu = lazyWithRetry(() => import("./Menu/Menu"));
const MenuDashBoard = lazyWithRetry(() => import("./MenuDashBoard/MenuDashBoard"));
const Reports = lazyWithRetry(() => import("./Reports/Reports"));
const Analytics = lazyWithRetry(() => import("./Analytics/Analytics"));
const ReportCompare = lazyWithRetry(() => import("./Reports/ReportCompare/ReportCompare"));
const TopRegionsV3 = lazyWithRetry(() => import("./Reports/TopRegionsV3/TopRegionsV3"));
const TopSoldProductsV3 = lazyWithRetry(() =>
  import("./Reports/TopSoldProductsV3/TopSoldProductsV3")
);
const DailyOrdersV3 = lazyWithRetry(() =>
  import("./Reports/DailyOrdersV3/DailyOrdersV3")
);
const PaymentMethodsV3 = lazyWithRetry(() =>
  import("./Reports/PaymentMethodsV3/PaymentMethodsV3")
);
const Orders = lazyWithRetry(() => import("./Orders/Orders"));
const MapContainer = lazyWithRetry(() => import("./MapBox/MapContainer"));
const MapContainerNew = lazyWithRetry(() => import("./MapBox/MapContainerNew"));
const Metrics = lazyWithRetry(() => import("./Metrics/Metrics"));
const GeneratedReports = lazyWithRetry(() =>
  import("./GeneratedReports/GeneratedReports")
);
const Terms = lazyWithRetry(() => import("./Terms/Terms"));
const Privacy = lazyWithRetry(() => import("./Privacy/Privacy"));
const Safe = lazyWithRetry(() => import("./Safe/Safe"));
const SingleBlog = lazyWithRetry(() => import("./SingleBlog/SingleBlog"));
const BlogArchive = lazyWithRetry(() => import("./BlogArchive/BlogArchive"));
const Landing = lazyWithRetry(() => import("./Landing/Landing"));
const MainLanding = lazyWithRetry(() => import("./MainLanding/MainLanding"));
const ResetPassword = lazyWithRetry(() => import("./ResetPassword/ResetPassword"));
const LoggedInUsers = lazyWithRetry(() =>
  import("./LoggedInUsers/LoggedInUsers")
);
const Payroll = lazyWithRetry(() => import("./Payroll/Payroll"));
const PayrollDetail = lazyWithRetry(() => import("./Payroll/PayrollDetail"));
const MyHours = lazyWithRetry(() => import("./Payroll/MyHours"));
const Alpineiq = lazyWithRetry(() => import("./Alpineiq/Alpineiq"));

export {
  MenuDashBoard,
  Alpineiq,
  Team,
  Orders,
  Patient,
  Reports,
  ReportCompare,
  TopRegionsV3,
  TopSoldProductsV3,
  DailyOrdersV3,
  PaymentMethodsV3,
  Analytics,
  Settings,
  Menu,
  Safe,
  MyAccount,
  Landing,
  BlogArchive,
  SingleBlog,
  MainLanding,
  Metrics,
  Terms,
  Privacy,
  MapContainer,
  MapContainerNew,
  GeneratedReports,
  PromoCodes,
  ResetPassword,
  LoggedInUsers,
  Payroll,
  PayrollDetail,
  MyHours,
};
